import { CONFIGURATION_KEYS, PARTICIPANTS_BULK, PROGRESS_STATES, ROLES } from 'constants/enums'
import { get } from 'lodash'

export default function({ withAwardUnit, isLabelsEnabled } = {}) {
  return [
    {
      id: 0,
      label: '',
      intlKey: '',
      sortableId: '',
      selector: true
    },
    {
      id: 1,
      label: 'ID',
      intlKey: 'table.id',
      sortable: true,
      sortableId: 'id'
    },
    {
      id: 2,
      label: 'First Name',
      intlKey: 'table.first_name',
      sortable: true,
      sortableId: 'participantPerson.firstName'
    },
    {
      id: 3,
      label: 'Last Name',
      intlKey: 'table.last_name',
      sortable: true,
      sortableId: 'participantPerson.lastName'
    },
    {
      id: 4,
      label: 'Registration Date',
      intlKey: 'table.registration_date',
      sortable: true,
      sortableId: 'award.createdAt'
    },
    {
      id: 5,
      label: 'Level',
      intlKey: 'table.level',
      sortable: true,
      sortableId: 'award.awardLevel.value'
    },
    {
      id: 6,
      label: 'Award Unit',
      intlKey: 'table.award_unit',
      sortable: true,
      sortableId: 'award.organization.name',
      hide: !withAwardUnit
    },
    {
      id: 7,
      label: 'Email Confirmation',
      intlKey: 'table.email_confirmation',
      sortable: true,
      sortableId: 'participantPerson.isEmailConfirmed'
    },
    {
      id: 8,
      label: 'Labels',
      intlKey: 'table.labels',
      sortableId: 'labels.label.name',
      hide: !isLabelsEnabled
    },
    {
      id: 9,
      label: 'Parent Approval',
      intlKey: 'table.parent_approval',
      sortable: true,
      sortableId: 'award.consentDeliveryType.value'
    },
    {
      id: 10,
      label: 'Payment',
      intlKey: 'table.payment',
      sortable: true,
      sortableId: 'award.paymentState.value'
    },
    {
      id: 11,
      label: 'Review',
      intlKey: 'table.review',
      sortable: false
    },
    {
      id: 12,
      label: 'Action',
      intlKey: 'table.action',
      sortable: false
    }
  ]
}


export const bulkAwardStateOptions = (intl, configuration, userType) => {
  const options = [{
    value: PROGRESS_STATES.awardRegApproval.id,
    label: intl.formatMessage({ id: 'button.approve', defaultMessage: 'Approve' })
    },
    {
      value: PARTICIPANTS_BULK.resendParentalConsent.id,
      label: intl.formatMessage({ id: 'button.resend_parental_consent', defaultMessage: 'Resend parental consent' })
    },
    {
      value: PARTICIPANTS_BULK.resendConfirmationEmail.id,
      label: intl.formatMessage({ id: 'label.resend_confirmation_email', defaultMessage: 'Resend confirmation email' })
    },
    {
      value: PARTICIPANTS_BULK.changeParentalConsent.id,
      label: intl.formatMessage({ id: 'label.change_parental_consent', defaultMessage: 'Change parental consent' })
    }
    ]

  if (userType !== ROLES.IF_STAFF_SUPER.u && get(configuration, `values[${CONFIGURATION_KEYS.enableLabels.id}].booleanValue`)) {
    options.push({
      value: PARTICIPANTS_BULK.assignLabels.id,
      label: intl.formatMessage({ id: 'label.assign_labels', defaultMessage: 'Assign Participant Labels' })
    })
  }

  if (userType !== ROLES.IF_STAFF_SUPER.u && get(configuration, `values[${CONFIGURATION_KEYS.enableLabels.id}].booleanValue`)) {
    options.push({
      value: PARTICIPANTS_BULK.unassignLabels.id,
      label: intl.formatMessage({ id: 'label.unassign_labels', defaultMessage: 'Unassign Participant Labels' })
    })
  }

  if (userType !== ROLES.IF_STAFF_SUPER.u && get(configuration, `values[${CONFIGURATION_KEYS.enableAwardLabels.id}].booleanValue`)) {
    options.push({
      value: PARTICIPANTS_BULK.assignAwardLabels.id,
      label: intl.formatMessage({ id: 'label.assign_award_labels', defaultMessage: 'Assign Award Labels' })
    })
  }

  if (userType !== ROLES.IF_STAFF_SUPER.u && get(configuration, `values[${CONFIGURATION_KEYS.enableAwardLabels.id}].booleanValue`)) {
    options.push({
      value: PARTICIPANTS_BULK.unassignAwardLabels.id,
      label: intl.formatMessage({ id: 'label.unassign_award_labels', defaultMessage: 'Unassign Award Labels' })
    })
  }

  options.push({
    value: PARTICIPANTS_BULK.collectEmails.id,
    label: intl.formatMessage({ id: 'contact.collect_emails', defaultMessage: 'Collect email addresses for emailing' })
  })

  return options
}

export const bulkForm = 'tasks-registrationParticipants-bulkChange'
